/**
 * SankeyDiagram - Custom Sankey node and link renderers
 * for the energy flow Sankey diagram.
 */

import React from 'react';
import { Layer, Rectangle } from 'recharts';
import { alpha } from '@mui/material/styles';
import { vortxTypography } from '@vortx/shared-ui';
import { COLORS } from './ResultsDesignTokens';

// Custom Sankey Node
export const SankeyNode = ({ x, y, width, height, index, payload }) => {
    const nodeColors = {
        'Solar PV': COLORS.solar,
        'Grid': COLORS.grid,
        'BESS': COLORS.bess,
        'EV Charging': COLORS.ev,
        'Losses': COLORS.loss,
        'Export': COLORS.export,
    };
    const color = nodeColors[payload.name] || COLORS.accent;

    return (
        <Layer key={`node-${index}`}>
            <Rectangle
                x={x}
                y={y}
                width={width}
                height={height}
                fill={color}
                fillOpacity={0.9}
                rx={4}
                ry={4}
                style={{
                    filter: `drop-shadow(0 0 8px ${alpha(color, 0.6)})`,
                }}
            />
            <text
                x={x < 200 ? x + width + 8 : x - 8}
                y={y + height / 2}
                textAnchor={x < 200 ? 'start' : 'end'}
                dominantBaseline="middle"
                style={{
                    fontFamily: vortxTypography.mono,
                    fontSize: '11px',
                    fontWeight: 600,
                    fill: COLORS.text.primary,
                }}
            >
                {payload.name}
            </text>
            <text
                x={x < 200 ? x + width + 8 : x - 8}
                y={y + height / 2 + 14}
                textAnchor={x < 200 ? 'start' : 'end'}
                dominantBaseline="middle"
                style={{
                    fontFamily: vortxTypography.mono,
                    fontSize: '10px',
                    fill: COLORS.text.muted,
                }}
            >
                {payload.value?.toFixed(0)} kWh
            </text>
        </Layer>
    );
};

// Custom Sankey Link
export const SankeyLink = ({ sourceX, targetX, sourceY, targetY, sourceControlX, targetControlX, linkWidth, index, payload }) => {
    const sourceColors = {
        'Solar PV': COLORS.solar,
        'Grid': COLORS.grid,
        'BESS': COLORS.bess,
    };
    const color = sourceColors[payload.source?.name] || COLORS.accent;

    return (
        <Layer key={`link-${index}`}>
            <path
                d={`
                    M${sourceX},${sourceY}
                    C${sourceControlX},${sourceY} ${targetControlX},${targetY} ${targetX},${targetY}
                `}
                fill="none"
                stroke={color}
                strokeWidth={linkWidth}
                strokeOpacity={0.4}
                style={{
                    filter: `drop-shadow(0 0 4px ${alpha(color, 0.3)})`,
                }}
            />
        </Layer>
    );
};
